import { MenuContainer } from './style';
import ThemeSwitch from '../../../ThemeSwitch';
import { useMsal } from '@azure/msal-react';
import Button from '../../../../Button';
import { TbSettings2 } from 'react-icons/tb';
import { TbLogout } from 'react-icons/tb';
import { TbListDetails } from 'react-icons/tb';
import { TbPlugConnected } from 'react-icons/tb';
import {
  useUpdateUserCompany,
  useUserCompanies,
  useUserCompaniesCurrentUserAdminState
} from '../../../../../services/user.service';
import { queryClient } from '../../../../../config/queryClient';
import { GET_WORKFLOW } from '../../../../../consts/queryKeys';
import { QUERY_KEYS } from '../../../../../services/constants';
import { Link, useNavigate } from 'react-router-dom';
import { USER_ROLES } from '../../../../../consts/userRoles';
import DesignSwitch from '../../../DesignSwitch';
import { FEATURE_FLAG_NAMES, useFeatureFlag } from '../../../../../hooks/useFeatureFlag';
import { useDesignPreference } from '../../../../../utils/design';

export default function Menu({ closePopover }) {
  const { instance } = useMsal();
  const { data: currentUserState } = useUserCompaniesCurrentUserAdminState();

  const isApprover = currentUserState?.role === USER_ROLES.APPROVER;
  // The new design calls the members page what it is.
  const isV2UI = useFeatureFlag(FEATURE_FLAG_NAMES.V2_UI);
  const design = useDesignPreference();
  const settingsLabel = isV2UI && design === 'v2' ? 'Team' : 'Settings';

  const onLogout = () => {
    instance.logoutRedirect();
  };

  return (
    <MenuContainer>
      <div className="menu-list">
        {currentUserState?.role === USER_ROLES.ADMIN && (
          <Link className="settings-button" to="/settings">
            <TbSettings2 size={16} color="#868E96" />
            {settingsLabel}
          </Link>
        )}

        {!isApprover && (
          <Link className="settings-button" to="/integrations" onClick={closePopover}>
            <TbPlugConnected size={16} color="#868E96" />
            Integrations
          </Link>
        )}

        {!isApprover && (
          <Link className="settings-button" to="/activity-log" onClick={closePopover}>
            <TbListDetails size={16} color="#868E96" />
            Activity log
          </Link>
        )}

        {/* A setting, among the settings. */}
        <DesignSwitch closePopover={closePopover} />
        <ThemeSwitch />

        <Button className="list-item" onClick={onLogout}>
          <TbLogout size={17} color="#868E96" />
          Logout
        </Button>
      </div>
    </MenuContainer>
  );
}
